import { render, staticRenderFns } from "./new_file.vue?vue&type=template&id=54a2172d&scoped=true"
import script from "./new_file.vue?vue&type=script&lang=js"
export * from "./new_file.vue?vue&type=script&lang=js"
import style0 from "./new_file.vue?vue&type=style&index=0&id=54a2172d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a2172d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54a2172d')) {
      api.createRecord('54a2172d', component.options)
    } else {
      api.reload('54a2172d', component.options)
    }
    module.hot.accept("./new_file.vue?vue&type=template&id=54a2172d&scoped=true", function () {
      api.rerender('54a2172d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/courseDeclare/new_file.vue"
export default component.exports